import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import styled from 'src/ui/library/styled';
import CaseDataPageFooter from '../../ReviewAndSubmit/CaseDataPageFooter';
import printIcon from '../../../../assets/dashboardIcons/printIcon.png';
import chevronLeft from '../../../../assets/dashboardIcons/chevron_left.png';
import chevronRight from '../../../../assets/dashboardIcons/chevron_rightIcon.png';
import downloadIcon from '../../../../assets/dashboardIcons/downloadIcon.png';
import ButtonComponent from 'src/new-ui/library/ButtonComponent/ButtonComponent';
import { saveCaseDataCollectQuestionnairePage, getReviewSummaryHtml } from 'src/services/questionnaire.service.js';
import { setCaseSubmitted } from 'src/new-ui/features/CaseDataCollect/state/caseDataCollectAction';
import Spinner from 'src/ui/library/Spinner/Spinner';

const styles = theme => ({
  reviewContainer: {
    '@global': {
      '.font-bold.font-18': {
        marginBottom: '10px',
      },
      '.inputField': {
        '.inputBox': {
          '&:nth-child(1)': {
            paddingRight: '8px',
          },
          '&:nth-child(2)': {
            paddingLeft: '8px',
          },
        },
      },
    },
  },

  divider: {
    margin: '6rem 0 1rem 0',
    background: '#E7E7EA',
  },

  headerLines: {
    fontSize: '16px',
    fontFamily: 'EYInterstate-Regular',
    margin: '2rem 0',
  },

  noteText: {
    fontSize: '12px',
    fontFamily: 'EYInterstate-Light',
    color: '#747480',
  },

  footerPadding: {
    padding: '0.5rem 0 1rem 0',
  },

  pageHeight: {
    minHeight: '62vh',
  },
});

const ReviewAndSubmitPres = ({ htmlCont, classes, ...props }) => {
  const entityId = props.location.pathname && props.location.pathname.split('/')[3];
  const pageId = props.location.pathname && props.location.pathname.split('/')[4];
  const [submitted, setSubmitted] = useState(false);
  const [html, setHTML] = useState({ __html: htmlCont });
  const [isLoaded, setIsLoaded] = useState(false);
  const [spinner, setSpinner] = useState(false);

  let page =
    props.caseDatacollectMenu &&
    props.caseDatacollectMenu.menuDetails &&
    props.caseDatacollectMenu.menuDetails.length > 0 &&
    props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === props.location.pathname.split('/')[3])[0] &&
    props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === props.location.pathname.split('/')[3])[0].subMenu &&
    props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === props.location.pathname.split('/')[3])[0].subMenu
      .length > 0 &&
    props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === props.location.pathname.split('/')[3])[0].subMenu[
      props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === props.location.pathname.split('/')[3])[0].subMenu
        .length - 1
    ];
  useEffect(() => {
    async function createMarkup() {
      let response;
      response = await getReviewSummaryHtml(entityId);
      const backendHtmlString = await response.htmlContent;
      setIsLoaded(true);
      setSubmitted(false);
      return { __html: backendHtmlString };
    }
    createMarkup().then(result => setHTML(result));
  }, [isLoaded, entityId]);
  const goToBackPage = props => {
    const pageid = props.location.pathname.split('/')[3];

    let back =
      props.caseDatacollectMenu &&
      props.caseDatacollectMenu.menuDetails &&
      props.caseDatacollectMenu.menuDetails.length > 0 &&
      props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === pageid)[0] &&
      props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === pageid)[0].subMenu &&
      props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === pageid)[0].subMenu.length > 0 &&
      props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === pageid)[0].subMenu[
        props.caseDatacollectMenu.menuDetails.filter(menudetail => menudetail.pageId === pageid)[0].subMenu.length - 2
      ];
    let loc = back && props.location.pathname && props.location.pathname.split('/');
    loc.splice(4, 1, back.pageId);
    let backUrl = loc.join('/');
    props.history.push(backUrl, back.pageState);
    setIsLoaded(false);
  };
  const handleSubmit = (entityId, pageId) => {
    setSubmitted(true);
    setSpinner(true);
    saveCaseDataCollectQuestionnairePage({
      entityId: entityId,
      isReviewSubmitPage: true,

      organizerInstanceId: 0,

      organizerTypeId: 0,

      yearTypeId: 0,

      pageId: pageId,

      pageSourceId: 0,

      languageId: 0,

      pageState: 0,

      isSubmitted: true,

      dataRequests: [],

      tables: [],
    }).then(response => {
      if (response && response.isSubmitted) {
        setSubmitted(true);
        props.setCaseSubmitted(true);
        props.enqueueSnackbar('submitted successfully', {
          variant: 'success',
        });
      } else {
        setSubmitted(false);
      }

      setSpinner(false);
    });
  };

  return (
    <Grid container>
      <Grid item lg={12} md={12} className={classes.reviewContainer}>
        {isLoaded && !spinner ? (
          <div>
            <Grid id="container" item lg={12} md={12} className={classes.pageHeight}>
              <div dangerouslySetInnerHTML={html} />
            </Grid>
            <hr className={classes.divider} />
            <Grid item sm={12} className={classes.footerPadding}>
              <CaseDataPageFooter>
                <div className="btnComp d-flex justify-content-end">
                  <ButtonComponent text="Print" style={{ display: 'none' }} imgLeft={printIcon} />
                  <ButtonComponent text="Download as PDF" onClick={() => props.onDownloadPDF()} imgLeft={downloadIcon} />
                  <ButtonComponent text="Back" imgLeft={chevronLeft} onClick={() => goToBackPage(props)} />
                  <ButtonComponent
                    styleType="primary"
                    className="primary-btn"
                    text="Submit"
                    imgRight={chevronRight}
                    disabled={submitted === true || page.pageState.toLowerCase() === 'complete'}
                    onClick={() => handleSubmit(entityId, pageId)}
                  />
                </div>
              </CaseDataPageFooter>
            </Grid>
          </div>
        ) : (
          <div style={{ marginTop: '10%', marginBottom: '10%' }}>
            <Spinner size={50} />
          </div>
        )}
      </Grid>
    </Grid>
  );
};
const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = {
  setCaseSubmitted,
};

export default connect(mapStateToProps, mapDispatchToProps)(styled(ReviewAndSubmitPres)(styles));
